import { haversineMeters } from './haversine';

const MapUtils = {
    getDistanciaEntrePontos(lat1, lat2, lon1, lon2) {
        if ((lat1 == lat2) && (lon1 == lon2)) {
            return 0;
        }
        const d = haversineMeters(lat1, lon1, lat2, lon2);
        return Number.isFinite(d) ? d : 0;
    },
    getDistanciaTotalPolyline(geojson) {
        if (!geojson || geojson.geometry.type !== 'LineString') {
            return 0;
        }

        const coords = geojson.geometry.coordinates;

        if (!coords || coords.length <= 0) {
            return 0;
        }

        let distancia = 0;
        for (let i = 0; i < coords.length - 1; i++) {
            distancia += this.getDistanciaEntrePontos(coords[i][1], coords[i + 1][1], coords[i][0], coords[i + 1][0]);
        }

        return distancia;
    },
    getPontoMaisProximoPolyline(ponto, geojson) {
        if (!geojson || geojson.geometry.type !== 'LineString') {
            return 0;
        }

        const coords = geojson.geometry.coordinates;

        if (!coords || coords.length <= 0) {
            return 0;
        }

        return coords.reduce((prev, curr) => {
            return (
                this.getDistanciaEntrePontos(ponto.lat, prev[1], ponto.lng, prev[0]) <
                    this.getDistanciaEntrePontos(ponto.lat, curr[1], ponto.lng, curr[0])
                    ? prev
                    : curr
            );
        });
    }
};

export default MapUtils;
